<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">

                

                <div class="col-md-10 col10 mt-2">

                    <h2 > What is Payment Link</h2>
                </div>

              
                
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="9">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/mR2MaKeeOEk"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-10 col10 mt-4"  (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="108">
                    <h2><b>Workflow</b></h2>
                    <label for="">The GIF below illustrates the workflow of a payment link.</label>
                </div>
                <div class="col-md-12 mt-3"  (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="108">
                    <img src="./assets/GIF/Payment Link workflow gif.gif" width="95%" height="89%" alt=""
                        style="border-radius: 10px;">
                </div>
                <div class="col-md-12 " (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="10">

                    <h2 > What is Payment Link</h2>
                    <label for="" class="spn mt-3 " >The payment Link section in PayG
                        enables
                        businesses to
                        generate
                        and share payment links with their customers. Payment links are the URLs
                        that
                        direct
                        customers to a secure payment page where they can make a payment for a
                        specific
                        product,
                        service, or invoice. These links are shared via various communication
                        channels
                        like
                        email, SMS, chat apps, etc. Payment links provided by PayG are an excellent
                        way
                        for
                        businesses to start accepting online payments quickly without the need for a
                        full-fledged website or integration with their existing platform. It
                        simplifies
                        the
                        payment process for customers and helps businesses increase their revenue by
                        offering a
                        seamless payment experience</label>
                  
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="11">
                    <h2 >
                        Benefits of Payment Link:
                    </h2>

                    <label for="" class="mt-3 spn" >Payment links offer several
                        benefits for
                        businesses
                        and
                        individuals, making the process of sending and receiving payments more
                        efficient
                        and
                        convenient. Here are some key advantages. </label>
              

                    <h5 class="mt-4" >Easy Sharing </h5>
                    <label for="" class="mt-3 spn" >Payment links allow users to
                        share a clickable
                        link
                        via
                        various channels, such as email, messaging apps, or social media, making it
                        convenient
                        for both the payer and the payee. </label>
                 

                    <h5 class="mt-4" >No Physical Presence Required </h5>
                    <label for="" class="mt-3 spn" >Payment links eliminate the need
                        for physical
                        presence
                        during
                        transactions, which is especially useful in remote or digital business
                        transactions.
                    </label>
                  

                    <h5 class="mt-4" >Instant Transactions: </h5>
                    <label for="" class="mt-3 spn" >Payment links facilitate faster
                        transactions
                        compared
                        to
                        traditional payment methods, as users can complete the payment process with
                        just
                        a
                        few
                        clicks. </label>
                
                    <h5 class="mt-4" >Real-Time Confirmation: </h5>
                    <label for="" class="mt-3 spn" >Both parties receive instant
                        confirmation of the
                        payment,
                        reducing the time and uncertainty associated with waiting for funds to
                        clear.
                    </label>
                

                    <h5 class="mt-4" >Secure Transactions:</h5>
                    <label for="" class="mt-3 spn" >Payment links often use secure
                        and encrypted
                        channels,
                        ensuring the safety of financial information during the transaction.
                    </label>
                

                    <h5 class="mt-4" >Multiple Payment Options: </h5>
                    <label for="" class="mt-3 spn" >Payment links can be configured
                        to accept various
                        payment
                        methods, such as credit/debit cards, digital wallets, or bank transfers,
                        offering
                        flexibility to payers</label>
                

                    <h5 class="mt-4" >Customization </h5>
                    <label for="" class="mt-3 spn" >Businesses can customize payment
                        links with
                        details
                        such
                        as
                        invoice information, due dates, or itemized lists to provide clarity to
                        customers.
                    </label>
                 
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="12">
                    <h2 >Use cases </h2>
                    <label for=""  class="spn mt-3">Payment links are used in various
                        contexts across
                        different
                        industries to facilitate transactions. Here are some common scenarios where
                        payment
                        links are often used: </label>
                    
                    <h5 class="mt-4" >E-commerce </h5>
                    <label for="" class="mt-3 spn" >In online retail, businesses
                        often generate
                        payment
                        links
                        for
                        specific products or services. Customers can click on the link to make a
                        payment
                        directly, streamlining the checkout process. </label>
                    

                    <h5 class="mt-4" >Invoicing </h5>
                    <label for="" class="mt-3 spn" >Businesses and freelancers use
                        payment links in
                        invoices.
                        Instead of traditional payment methods, recipients can click on the payment
                        link
                        to
                        settle the invoice, making the payment process more convenient. </label>
                    

                    <h5 class="mt-4" >Service Providers </h5>
                    <label for="" class="mt-3 spn" >Professionals and service
                        providers, such as
                        consultants
                        or
                        contractors, may use payment links to request payments for their services.
                        This
                        method
                        simplifies the payment process for both parties. </label>
                    

                    <h5 class="mt-4" >Donations and Fundraising </h5>
                    <label for="" class="mt-3 spn" >Non-profit organizations and
                        individuals
                        conducting
                        fundraising campaigns often use payment links to collect donations. It
                        provides
                        a
                        straightforward way for supporters to contribute.

                    </label>
                   

                    <h5 class="mt-4" >Event Registration </h5>
                    <label for="" class="mt-3 spn" >When organizing events,
                        organizers can use
                        payment
                        links
                        for
                        ticket sales or registration fees. Attendees can click on the link to pay
                        for
                        their
                        participation.

                    </label>
                
                    <h5 class="mt-4" >Peer-to-Peer Transactions </h5>
                    <label for="" class="mt-3 spn" >Individuals may generate payment
                        links to request
                        or
                        send
                        money to friends, family, or colleagues. This is common in situations where
                        splitting
                        bills or sharing expenses.

                    </label>
                  

                    <h5 class="mt-4" >Subscription Services </h5>
                    <label for="" class="mt-3 spn" >Companies offering
                        subscription-based services
                        may
                        use
                        payment links for initial sign-ups or to collect recurring payments from
                        subscribers.

                    </label>
                    
                    <label for="" class="mt-3 spn" >The versatility of payment links
                        lies in their
                        simplicity
                        and
                        ease of use. They provide a convenient way to handle financial transactions
                        without
                        the
                        need for complex payment gateways or extensive setup processes.
                    </label>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
              
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#9">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover" [ngClass]="{'video':colors=='1'}"
                                    (click)="color('1')">
                                    What is a payment link? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#9">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/workflow.svg" class="tab-icon intro" alt=""> </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('108')">
                                    Workflow </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#10">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')" >
                                    What is a payment link? </span>
                          
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#11">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')" >Benefits
                                    of a
                                    Payment Link</span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#12">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')" >
                                    Where are payment links used? </span>
                              
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:60%">
                <a [routerLink]="['/introduction-reseller']">  <button class="btn btn-color " (click)="menues('Web Integration')" >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Sales Partner
                </button></a>
              
            </div>
            <div class="col-md-4   " style="width:40%">
                <a [routerLink]="['/create-link']">   <button class="btn btn-color" (click)="menues('Create Payment')" >How
                    to
                    Create Payment
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>